<div class="container-header">
  <div class="admin">
   Admin Dashboard
  </div>
  <div class="profile-section">
    <div class="setting">
      <mat-icon class="icon">settings</mat-icon>
    </div>
    <div class="notification">
      <mat-icon class="icon" >notifications</mat-icon>
    </div>
    <div class="profile">
      <img [src]="'https://www.w3schools.com/howto/img_avatar.png'"  alt="fix"/>
    </div>
  </div>
</div>
